import {useMediaQuery} from 'react-responsive';

export const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1200 })
    return isDesktop ? children : null
}

export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 1199 })
    return isMobile ? children : null
}